module.exports = __webpack_public_path__ + "img/search-dark-green-outline@3x.93019353.svg";